import React from 'react';
import { cn } from '../cn';
/**
 * Unified data-table shell: rounded corners, border, card background, horizontal scroll.
 *
 * Use when a card-like frame around the table is needed. If the table is inside a bordered Card, pass `borderless`
 * to avoid double borders.
 */
export const DataTableShell = ({ children, className, borderless }) => {
    return (React.createElement("div", { className: cn('overflow-hidden rounded-lg bg-card', !borderless && 'border border-border shadow-sm', className) },
        React.createElement("div", { className: "relative w-full overflow-x-auto" }, children)));
};
export default DataTableShell;
